import {BridgeComponent} from "@hotwired/hotwire-native-bridge"

export class BridgeToastController extends BridgeComponent {
    static component = "toast"
    static values = {
        level: String,
        message: String
    }

    connect() {
        super.connect()
        if (!this.bridgeElement.enabled) return

        this.send("connect", {
            level: this.levelValue,
            message: this.messageValue
        })

        // Remove the HTML toast so the user doesn't see both the web alert
        // and the native toast. data-turbo-permanent on the root div is
        // superseded by explicit removal; next flash emits a fresh element.
        this.element.remove()
    }
}
